const ATTARIYE_FUZZY_TERMS = [
  'yerli',
  'kemik',
  'tarak',
  'tarağı',
  'ahşap',
  'bıçak',
  'bıçağı',
  'tırnak',
  'makas',
  'makasları',
  'manikür',
  'sakal',
  'tıraş',
  'fırça',
  'fırçaları',
  'şef',
  'et',
  'ekmek',
  'sebze',
  'meyve',
  'soyacak',
  'bileme',
  'masat',
  'tirbuşon',
  'törpü',
  'ayna',
  'jilet',
  'kişisel',
  'bakım',
  'mutfak',
  'çanta',
  'aksesuar',
  'masaj',
  'alet',
  'aletleri',
  'sigara',
  'tabakası',
  'şişe',
  'açacağı',
  'outdoor',
  'çakı',
  'saç',
  'boynuz',
  'sığır',
  'koç',
  'manda',
  'doğal',
  'seyrek',
  'dişli',
  'çift',
  'taraflı',
  'bit',
  'kepek',
  'cep',
  'saplı',
  'pelesenk',
  'sandal',
  'meridyen',
  'akupresür',
  'refleksoloji',
  'gua',
  'sha',
  'kafa',
  'derisi',
  'boyun',
  'omuz',
  'ense',
  'ustura',
  'katlanır',
  'askı',
  'askılık',
  'kristal',
  'masa',
  'anahtar',
  'pirinç',
  'kasap',
  'profesyonel',
  'paslanmaz',
  'çelik',
  'sorendy',
  'attariye',
  'merkur',
  'arcos',
  'victorinox',
  'solingen',
  'zwilling',
  'dovo',
  'jaguar',
];

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.activeCorrection = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    this.activeCorrection = '';

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (this.activeCorrection && this.getQuery() === this.searchTerm) {
      this.input.value = this.activeCorrection;
    }

    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.activeCorrection = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      const previousTermMatches = currentButtonText.match(new RegExp(this.escapeRegExp(previousTerm), 'g'));

      if (previousTerm && previousTermMatches && previousTermMatches.length > 1) {
        return;
      }

      const newButtonText = previousTerm
        ? currentButtonText.replace(previousTerm, newTerm)
        : currentButtonText;
      searchForTextElement.innerText = newButtonText;
    }
  }

  escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  async getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, '-').toLocaleLowerCase('tr-TR');
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      const cachedResult = this.cachedResults[queryKey];
      this.activeCorrection = cachedResult.correction || '';
      this.renderSearchResults(cachedResult.markup);
      return;
    }

    try {
      const nativeResult = await this.fetchPredictiveSearch(searchTerm);

      if (this.getQuery() !== searchTerm) return;

      if (nativeResult.productCount > 0) {
        this.cacheResult(queryKey, nativeResult.markup, '');
        this.activeCorrection = '';
        this.renderSearchResults(nativeResult.markup);
        return;
      }

      const correctedTerm = this.getFuzzyCorrection(searchTerm);

      if (!correctedTerm || correctedTerm === searchTerm) {
        this.cacheResult(queryKey, nativeResult.markup, '');
        this.activeCorrection = '';
        this.renderSearchResults(nativeResult.markup);
        return;
      }

      const correctedResult = await this.fetchPredictiveSearch(correctedTerm);

      if (this.getQuery() !== searchTerm) return;

      if (correctedResult.productCount === 0) {
        this.cacheResult(queryKey, nativeResult.markup, '');
        this.activeCorrection = '';
        this.renderSearchResults(nativeResult.markup);
        return;
      }

      const correctedMarkup = this.addCorrectionSuggestion(correctedResult.markup, correctedTerm);
      this.cacheResult(queryKey, correctedMarkup, correctedTerm);
      this.activeCorrection = correctedTerm;
      this.renderSearchResults(correctedMarkup);
    } catch (error) {
      if (error?.name === 'AbortError' || error?.code === 20) return;
      this.close();
      throw error;
    }
  }

  async fetchPredictiveSearch(searchTerm) {
    const response = await fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`,
      {
        signal: this.abortController.signal,
      }
    );

    if (!response.ok) {
      throw new Error(response.status);
    }

    const text = await response.text();
    const parsedDocument = new DOMParser().parseFromString(text, 'text/html');
    const section = parsedDocument.querySelector('#shopify-section-predictive-search');
    const markup = section?.innerHTML || '';
    const productCount = section?.querySelectorAll('.predictive-search__product-card-title').length || 0;

    return { markup, productCount };
  }

  cacheResult(queryKey, markup, correction) {
    this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
      predictiveSearchInstance.cachedResults[queryKey] = { markup, correction };
    });
  }

  getFuzzyCorrection(searchTerm) {
    const parts = searchTerm.match(/\S+|\s+/g) || [];
    let correctedTokens = 0;

    const correctedParts = parts.map((part) => {
      if (/^\s+$/.test(part) || correctedTokens >= 3) return part;

      const correction = this.findClosestFuzzyTerm(part);

      if (!correction) return part;

      correctedTokens += 1;
      return this.matchCase(part, correction);
    });

    if (!correctedTokens) return '';

    return correctedParts.join('').trim();
  }

  findClosestFuzzyTerm(token) {
    const normalizedToken = this.normalizeFuzzyText(token);

    if (normalizedToken.length < 4) return '';

    const maxDistance = normalizedToken.length <= 5 ? 1 : 2;
    let bestTerm = '';
    let bestDistance = Number.POSITIVE_INFINITY;
    let bestLengthDifference = Number.POSITIVE_INFINITY;

    ATTARIYE_FUZZY_TERMS.forEach((term) => {
      const normalizedTerm = this.normalizeFuzzyText(term);

      if (!normalizedTerm) return;
      if (normalizedToken === normalizedTerm && token.toLocaleLowerCase('tr-TR') === term.toLocaleLowerCase('tr-TR')) return;
      if (normalizedToken[0] !== normalizedTerm[0]) return;

      const lengthDifference = Math.abs(normalizedToken.length - normalizedTerm.length);
      if (lengthDifference > 2) return;

      const distance = this.damerauLevenshtein(normalizedToken, normalizedTerm);
      if (distance > maxDistance) return;

      if (
        distance < bestDistance ||
        (distance === bestDistance && lengthDifference < bestLengthDifference)
      ) {
        bestTerm = term;
        bestDistance = distance;
        bestLengthDifference = lengthDifference;
      }
    });

    return bestTerm;
  }

  normalizeFuzzyText(value) {
    return value
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .replace(/ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/ç/g, 'c')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  damerauLevenshtein(source, target) {
    const sourceLength = source.length;
    const targetLength = target.length;
    const maxDistance = sourceLength + targetLength;
    const matrix = Array.from({ length: sourceLength + 2 }, () => Array(targetLength + 2).fill(0));
    const lastSeen = new Map();

    matrix[0][0] = maxDistance;

    for (let i = 0; i <= sourceLength; i += 1) {
      matrix[i + 1][0] = maxDistance;
      matrix[i + 1][1] = i;
    }

    for (let j = 0; j <= targetLength; j += 1) {
      matrix[0][j + 1] = maxDistance;
      matrix[1][j + 1] = j;
    }

    for (let i = 1; i <= sourceLength; i += 1) {
      let db = 0;

      for (let j = 1; j <= targetLength; j += 1) {
        const i1 = lastSeen.get(target[j - 1]) || 0;
        const j1 = db;
        let cost = 1;

        if (source[i - 1] === target[j - 1]) {
          cost = 0;
          db = j;
        }

        matrix[i + 1][j + 1] = Math.min(
          matrix[i][j] + cost,
          matrix[i + 1][j] + 1,
          matrix[i][j + 1] + 1,
          matrix[i1][j1] + (i - i1 - 1) + 1 + (j - j1 - 1)
        );
      }

      lastSeen.set(source[i - 1], i);
    }

    return matrix[sourceLength + 1][targetLength + 1];
  }

  matchCase(original, corrected) {
    if (original === original.toLocaleUpperCase('tr-TR')) {
      return corrected.toLocaleUpperCase('tr-TR');
    }

    if (
      original.charAt(0) === original.charAt(0).toLocaleUpperCase('tr-TR') &&
      original.slice(1) === original.slice(1).toLocaleLowerCase('tr-TR')
    ) {
      return corrected.charAt(0).toLocaleUpperCase('tr-TR') + corrected.slice(1);
    }

    return corrected;
  }

  addCorrectionSuggestion(markup, correctedTerm) {
    const parsedDocument = new DOMParser().parseFromString(
      `<div id="attariye-fuzzy-wrapper">${markup}</div>`,
      'text/html'
    );
    const wrapper = parsedDocument.querySelector('#attariye-fuzzy-wrapper');

    if (!wrapper) return markup;

    const suggestion = parsedDocument.createElement('div');
    suggestion.className = 'predictive-search__fuzzy-suggestion';
    suggestion.setAttribute(
      'style',
      'padding: 1.2rem 2rem; border-bottom: 0.1rem solid rgba(var(--color-foreground), 0.08); font-size: 1.4rem;'
    );

    const label = parsedDocument.createElement('span');
    label.textContent = 'Bunu mu demek istediniz? ';

    const link = parsedDocument.createElement('a');
    const searchUrl = routes.search_url || '/search';
    link.href = `${searchUrl}?q=${encodeURIComponent(correctedTerm)}`;
    link.className = 'link underlined-link';
    link.textContent = correctedTerm;

    suggestion.append(label, link);
    wrapper.prepend(suggestion);

    return wrapper.innerHTML;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');
    this.setLiveRegionText(countElement?.textContent || '');
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
